import Left from "./Left"
import Top from "./Top"

export default {
  Left,
  Top,
}
